import LoginComponent from "~/components/pages/login";

export default function LoginPage() {
  return <LoginComponent />;
}
